<button mat-icon-button
  class="container"
  matTooltip="{{ getTooltip() }}"
  (click)="$event.stopPropagation();openDetailsDialog($event)"
  target="_blank"
  >
  <span>{{(contact.firstName ? contact.firstName[0] : '') | uppercase}}</span>
  <span>{{(contact.lastName ? contact.lastName[0] : '') | uppercase}}</span>
</button>
